export default __webpack_public_path__ + "static/media/colleagues-discussing-work-dark-office.7505b07b.jpg";